/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 11:52:57
 */
import { Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import { ProcessingParams } from "../../services/processing";
import { ProcessingDataColumn } from "./columns";
import { ProcessingDataModal } from "./modal";
import styles from "./ProcessingData.module.css";
import {
  getProcessingListAsync,
  selectProcessingList,
} from "./ProcessingDataSlice";
import { ProcessingDataQuery } from "./query";

export const ProcessingData = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [id, setId] = useState("");

  const [queries, setQueries] = useState<ProcessingParams>({
    pn: 1,
    ps: 10,
  });

  const page = useSelector(selectProcessingList);

  useEffect(() => {
    if (JSON.stringify(queries) !== "{}") {
      dispatch(getProcessingListAsync({ ...queries }));
    }
  }, [dispatch, queries]);

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            flex: "1",
            background: "#fff",
            borderRadius: "10px",
            padding: 20,
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
          <ProcessingDataQuery
            onChange={(v) => {
              setQueries({ ...v, pn: 1, ps: 10 });
            }}
          />
        </div>
      </div>
      <div style={{ height: "calc(100% - 130px)" }} className={styles.ProcessingData}>
      <div
          style={{
            width: "100%",
            height: "calc(100% - 55px)",
            overflow: "auto",
          }}
        >
        <Table
          rowKey={(record) => record.disposeId}
          className={styles.ProcessingTable}
          pagination={false}
          style={{ height: "100%" }}
          dataSource={page.records}
          columns={ProcessingDataColumn((t, id) => {
            if (t === "look") {
              setId(id);
            }
          }, page.size * (page.current - 1))}
          onRow={(r) => ({
            onDoubleClick: () => setId(r.disposeId.toString()),
          })}
        />
        <Pagination
          total={page.total}
          current={page.current}
          pageSize={page.size}
          showSizeChanger
          showQuickJumper
          style={{
            position: "absolute",
            bottom: "40px",
            right: "40px",
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={(current, size) => {
            setQueries({ ...queries, pn: current, ps: size });
          }}
        />
        </div>
      
      <ProcessingDataModal
        id={id}
        visible={!!id}
        onCancel={() => {
          setId("");
        }}
        onOk={() => {
          setId("");
        }}
      />
      </div>
    </div>
  );
};
